<div class="action-panel">
  <div class="action-panel-header instructions-header" (click)="accordionAction()" style="cursor: pointer;">
    <i class="fa fa-info-circle" style="margin-right:6px;"></i>
    <span class="instructions-title">Welcome to your personal space</span>
    <i class="fa instructions-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div class="action-panel-body">
    <p class="action-panel-desc instructions-intro">
      This is your personal space on the HSbooster.eu platform. You will need to enter this space to track your activities and report on the projects&rsquo; progress. Using the platform is important to monitor the outputs of the services and is requested for the correct completion of the assignments.
    </p>

    <div *ngIf="opened" class="instructions-body">
      <p>The service consists of minimum 2 and up to 4 meetings with your assigned project, to be carried out over a period of maximum 3 months.</p>

      <p>The two compulsory meetings are:</p>
      <ul>
        <li><strong>First Meeting</strong> at the start of the service to discuss needs and expectations</li>
        <li><strong>Final Meeting</strong> at the end of the service to comment on the activities carried out and suggest a future strategy</li>
      </ul>

      <p>The optional meetings are:</p>
      <ul>
        <li>Meetings in between to better formulate your advice, gather additional information, or investigate particular aspects that may be helpful for your reporting</li>
      </ul>

      <p>At the end of the first meeting you will be asked to confirm if you need one or more additional meetings before providing your advice on the activities to perform.</p>

      <p>Please remember that, as necessary steps to progress from one meeting to the next, you need to:</p>
      <ol>
        <li>Schedule the calls with the project and insert the scheduled dates</li>
        <li>Fill in the <strong>activity report</strong> in all its sections by the end of the service</li>
      </ol>

      <p><strong>Filling in the report in all its sections is mandatory for the service to be considered completed and paid to you.</strong></p>
      <p><strong>Please have a look at such report before starting!</strong></p>

      <h6 class="instructions-section-title">How to fill in the activity report</h6>
      <p>The report is always available for you to fill in at any moment. It requires a set of information that you can typically collect before or during the first meeting with the project that helps set the scene and the expectations for the service.</p>
      <p>The report also presents a list of activities among which you should select the most appropriate and suggest them to the project, also ticking those that are actually carried out during the service.</p>
      <p>During the last meeting you are finally expected to guide the project towards the next steps and suggest a strategy to move forward after the service.</p>

      <h6 class="instructions-section-title">Useful materials and information</h6>
      <p>There is a set of useful materials and information you can refer to, beyond the activity report:</p>
      <ul>
        <li>Project contacts to get in touch with a representative of the projects assigned to you</li>
        <li>PPT templates that you can use, if you like, for any presentations you would like to prepare for your meetings with the project</li>
        <li>Suggested e-mail templates for your communications with the project</li>
      </ul>
      <p>You can find these templates in the pages dedicated to each of your assigned projects.</p>

      <p class="instructions-cta">You can now start! Please click on one of your projects below for further details.</p>
    </div>
  </div>
</div>
